import { addTab } from "../../../redux/slices/shipmentSlice";

export const openShipmentDetailTab = (dispatch, navigate, shipmentNumber, shipmentOfficeCode) => {
  if (!shipmentNumber) return;

  navigate("/dashboard/shipments");
  dispatch(
    addTab({
      id: `view-${shipmentNumber}-${Date.now()}`,
      name: `${shipmentNumber}`,
      contentType: "shipmentView",
      shipmentNumber,
      shipmentOfficeCode,
      isDynamic: true,
      createdAt: Date.now(),
    })
  );
};
